import { getAccountId } from '~/helpers'

export const QUERY_KEY_GET_AD_SIZES = ['get-ad-sizes', 'all', getAccountId()]
